import React from "react";

import { RoiSelectorSection } from "../model/roi-request-create.types";
import * as Styled from "./roi-request-create-selector.styled";

interface IRoiRequestCreateSectionTabsProps {
  sections: RoiSelectorSection[];
  activeSectionId: string;
  // eslint-disable-next-line no-unused-vars
  onTabClick: (...args: [string]) => void;
}

export const RoiRequestCreateSectionTabs = ({
  sections,
  activeSectionId,
  onTabClick,
}: IRoiRequestCreateSectionTabsProps) => {
  const visibleSections = sections
    .filter((section) => !section.locked)
    .slice(0, 9);
  const hiddenSectionsCount = sections.filter(
    (section) => section.locked,
  ).length;

  return (
    <Styled.TabsList>
      {visibleSections.map((section) => {
        const isLocked = !!section.disabled;

        return (
          <Styled.TabButton
            key={section.section_id}
            type="button"
            $isActive={activeSectionId === section.section_id}
            $isLocked={isLocked}
            onClick={() => onTabClick(section.section_id)}
            disabled={isLocked}
          >
            <Styled.TabLabel>
              <span>{section.label}</span>
              {isLocked ? (
                <Styled.LockedBadge>Locked</Styled.LockedBadge>
              ) : null}
            </Styled.TabLabel>
          </Styled.TabButton>
        );
      })}
      {hiddenSectionsCount > 0 ? (
        <Styled.TabButton type="button" $isLocked disabled>
          <Styled.TabLabel>
            <span>+{hiddenSectionsCount} more</span>
            <i className="pi pi-lock" aria-hidden="true" />
          </Styled.TabLabel>
        </Styled.TabButton>
      ) : null}
    </Styled.TabsList>
  );
};
